import React, { Component } from 'react';
import ReportPage from './ReportPage';
import RiskProfileChart from '../RiskProfileChart';

class RiskProfilePage extends Component {
    render() {
        return (
            <ReportPage {...this.props} 
                title={this.props.preparedFor + ' Plan Profile'}
                subtitle="Target-Date Blueprint has assessed the plan’s demographics and preferences based on your responses to the preceding questions. 
                The graphic below depicts your plan’s unique risk profile. The TDF rankings on the following screen reflect this profile."
                pageNumber={this.props.pageNumber}>
                <div className="mt-5">
                    <RiskProfileChart/>
                </div>
            </ReportPage> 
        );
    }
}

export default RiskProfilePage;
